import { useContext } from "react";
import { UsersAndGroupsContext } from "./UsersAndGroups.context";

export const useUsersAndGroupsContext = () => {
  const usersAndGroupsContext = useContext(UsersAndGroupsContext);
  if (usersAndGroupsContext === undefined) {
    throw new Error("usersAndGroupsContext must be inside of UsersAndGroupsContext");
  }
  return usersAndGroupsContext;
};
